import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidCategoriseYesNo } from '../../../../../mechanics/rid-categorise-yes-no/rid-categorise-yes-no';

@Component({
  selector: 'app-yes-no-mixed-page',
  imports: [RidCategoriseYesNo],
  templateUrl: './yes-no-mixed-page.html',
})
export class YesNoMixedPage {
  protected readonly $router = inject(Router);
}
